export const CHOOSE_LANGUAGE_ALERT_DID_PROMPT_KEY =
  "CHOOSE_LANGUAGE_ALERT_DID_PROMPT_KEY";

export const REFRESH_TOKEN_STORAGE_KEY = "REFRESH_TOKEN_STORAGE_KEY";
